export default __webpack_public_path__ + "static/media/SndLowerXSlideDown2.a383c5c1.mp3";